import { lazy } from "react";

export const WeekendWorkRequestPage = lazy(() => import("./page"));
export {
  REQUEST_WEEKEND_WORK_CREATE_PATH,
  REQUEST_WEEKEND_WORK_EDIT_PATH,
} from "./weekend-work-request-path";
export { ToWeekendWorkRequest } from "./to-weekend-work-request";
